import React, { useState } from 'react';
import { Card, Icon, Button, Collapse } from 'antd';
import AccessibilitySummaryEditor from '../../containers/SidebarMenu/AccessibilitySummaryEditor';
import { AccessibilityContent } from './style';
import { useTranslation } from 'react-i18next';
import { ACCESSIBILITY_TOOL_TIPS } from '../../containers/ComplexDocumentDesign/translationValues';


const { Panel } = Collapse;

const NAMESPACES = ['ACCESSIBILITY_VALIDATOR_TRANSLATION'];

const GetBlockSummaryFromValidator = (props) => {

  const { t } = useTranslation(NAMESPACES);
  const { accessibilityContext, setAccessibilityContext, onBlockSummarySave, scrollToElement } = props;
  const [blockSummaryInput, setBlockSummaryInput] = useState({});

  const DEFAULT_VALUE = [
    {
      contentType: 'PARAGRAPH',
      content: ''
    },
    {
      contentType: "LINE_BREAK",
      content: "\n"
    }
  ];

  const getAltText = (index, item) => {
    setBlockSummaryInput(prev => ({ ...prev, [item.blockUUID]: true }));
  }

  const removeBlockByUUID = (blockUUIDToRemove, flow) => {
    setAccessibilityContext(prevState => {
      const updatedPage = {
        ...prevState[flow],
        summaries: prevState[flow].summaries.filter(
          item => item.blockUUID !== blockUUIDToRemove
        ),
      };
      return {
        ...prevState,
        [flow]: updatedPage,
      };
    });
  };

  const handleClick = (e, item, flow) => {
    removeBlockByUUID(item.blockUUID, flow)
    onBlockSummarySave(e, item, accessibilityContext[flow].flowUUID)
  }

  const handleChange = () => {    
    setBlockSummaryInput({})
  }
 
  const inputBlockSummary = (idx, item, flowID, flow) => {
    return (
      <>
        {blockSummaryInput[item.blockUUID] && <AccessibilityContent>
          <AccessibilitySummaryEditor
            key={item.blockUUID}
            itemUUID={`block-summary-${item.blockUUID}`}
            contents={DEFAULT_VALUE}
            customContainerStyle={{ marginTop: 10 }}
            onSaveChanges={(e) => handleClick(e, item, flow)}
            customizeHistory={false}
            customClassName={'summary-editor'}
            blockID = {item.blockUUID}
          />
        </AccessibilityContent>}
      </>
    )
  }

  return (
    <>
      <div>
        {accessibilityContext.flows.map((flow) => {
          return (
            <>
              {accessibilityContext[flow]?.summaries?.length > 0 && <div style={{ marginTop: '8px' }}>
                <Collapse bordered={false} expandIconPosition={'right'} onChange={handleChange} className='card-design' defaultActiveKey={['Page 1']}>
                  <Panel key={flow} header={
                    <div className='accordion-header'>
                      <span>{flow}</span>
                      <span style={{ marginRight: '4px', float: 'right' }}>
                        {t(
                          ACCESSIBILITY_TOOL_TIPS.FINDINGS.key,
                          ACCESSIBILITY_TOOL_TIPS.FINDINGS.value,
                        )}
                        {accessibilityContext[flow]?.summaries?.length}
                      </span>
                    </div>
                  }>
                    <div className='scrollable-section'>
                      {accessibilityContext[flow].summaries.map((item, idx) => (
                        <>
                          <Card
                            key={`image-card-${flow}-${idx}`}
                            className="ind-card"
                          >
                            <div className="section-card">
                              <div className='title-style' onClick={() => scrollToElement(accessibilityContext[flow].flowUUID, item.blockUUID)}>
                                <Icon type="double-right" />
                                <p style={{ color: 'white', width: '90%' }}>
                                  {t(
                                    ACCESSIBILITY_TOOL_TIPS.NAVIGATE_TO_SECTION.key,
                                    ACCESSIBILITY_TOOL_TIPS.NAVIGATE_TO_SECTION.value,
                                  )}
                                </p>
                              </div>

                              <div className='section-card'>
                                {!blockSummaryInput[item.blockUUID] && <Button onClick={() => getAltText(idx, item)}>
                                  {t(
                                    ACCESSIBILITY_TOOL_TIPS.PROVIDE_SUMMARY.key,
                                    ACCESSIBILITY_TOOL_TIPS.PROVIDE_SUMMARY.value,
                                  )}
                                </Button>}
                                {inputBlockSummary(idx, item, accessibilityContext[flow].flowUUID, flow)}
                              </div>
                            </div>
                          </Card>
                        </>
                      ))}
                    </div>
                  </Panel>
                </Collapse>

              </div>}
            </>
          );
        })}

      </div>
    </>
  );
}

export default GetBlockSummaryFromValidator;